//#region IMPORT
import React from 'react';
/** Components Import */
import FileUploadDialog from '../../../../Components/FileUploadDialog/FileUploadDialog';
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import {
  getColumnDefs1,
  getColumnDefs2,
} from './HEA_BASIC_01_ColumnDefs';
/** Icons Import */

//#endregion
function HEA_BASIC_01(props) {
  //#region 변수
  const columnDefs1 = getColumnDefs1(props);
  const columnDefs2 = getColumnDefs2();
  //#endregion

  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => {
          return params.data.no;
        }}
        deleteYn1={'Y'}
        gridRef={props.gridRef1}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        addClick1={() => {
          if (!props.validateSelection()) return;

          props.rowClickData.current = null;
          props.setModalToggle1(true);
        }}
        deleteClick1={(e) => {
          if (!props.validateSelection()) return;

          const newRowExists = props.selectedRowData1.some(
            (row) => row.newYn === 'Y'
          );

          if (!newRowExists) {
            props.MarkedForDeletion1(props.selectedRowData1);
          } else {
            props.NewYnErrorMsg();
          }
        }}
        refreshClick1={(e) => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        fileUploadYn1={'Y'}
        fileDownloadYn1={'Y'}
        fileUploadClick1={() => {
          if (!props.validateSelection()) return;
          props.fileInputRef?.current?.click();
        }}
        fileDownloadClick1={() => {
          if (!props.validateSelection()) return;
          props.ExcelDownload1?.();
        }}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        onCellValueChanged={(e) => {
          const key = e.data.no;
          const field = e.colDef.field;
          const newValue = e.newValue;

          // 검진일 변경 시 유효일자 자동 계산
          if (field === 'hcDate') {
            const cycle = e.data.hcCycle;
            if (newValue && cycle) {
              const checkupDate = new Date(newValue);
              if (!isNaN(checkupDate.getTime())) {
                const validityDate = new Date(checkupDate);
                validityDate.setFullYear(
                  validityDate.getFullYear() + parseInt(cycle)
                );
                e.node.setDataValue('hcEffeDate', validityDate.toISOString());
              }
            }
          }

          // 검진주기 변경 시 유효일자 자동 계산
          if (field === 'hcCycle') {
            const checkupDate = e.data.hcDate;
            if (newValue && checkupDate) {
              const date = new Date(checkupDate);
              if (!isNaN(date.getTime())) {
                const validityDate = new Date(date);
                validityDate.setFullYear(
                  validityDate.getFullYear() + parseInt(newValue)
                );
                e.node.setDataValue('hcEffeDate', validityDate.toISOString());
              }
            }
          }

          e.node.setData({
            ...e.data,
            editYn: 'Y',
          });

          props.setChangedRowData1?.((prev) => {
            const filtered = prev.filter((row) => row.no !== key);
            return [...filtered, { ...e.data, editYn: 'Y' }];
          });
        }}
        onCellClicked={(e) => {
          const gridApi = props.gridRef1.current.api;
          const clickedRowIndex = e.rowIndex;

          const isCheckboxClick = e.event?.target?.type === 'checkbox';

          if (!isCheckboxClick) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
            gridApi.setFocusedCell(clickedRowIndex, 'coNm');

            const copied = JSON.parse(JSON.stringify(e.data));
            props.handleRowSelection1(copied, clickedRowIndex);

            gridApi
              .getDisplayedRowAtIndex(clickedRowIndex)
              ?.setSelected(true, false);
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);
          props.selectedRowNosRef1.current = new Set(
            selectedData.map((r) => r.no)
          );
          props.setSelectedRowData1(selectedData);
        }}
        isExternalFilterPresent={() => true}
        doesExternalFilterPass={(node) => {
          return node.data?.hcGubun === '일반';
        }}
      />
      {props.fileModalToggle && (
        <FileUploadDialog
          open={props.fileModalToggle}
          onClose={() => {
            props.setFileModalToggle(false);
          }}
          gridRef={props.gridRef1}
          selectedRowData={props.selectedRowData1}
          setSelectedRowData={props.setSelectedRowData1}
          setChangedRowData={props.setChangedRowData1}
          fileNameField={props.currentFileFieldType === 'hcCheckupFile' ? 'hcCheckupAttachmentFileName' : 'hcPostcareAttachmentFileName'}
          saveNameField={props.currentFileFieldType === 'hcCheckupFile' ? 'hcCheckupAttachmentSaveName' : 'hcPostcareAttachmentSaveName'}
          filePathField={props.currentFileFieldType === 'hcCheckupFile' ? 'hcCheckupAttachmentFilePath' : 'hcPostcareAttachmentFilePath'}
          SaveLogicPreview={props.SaveLogicPreview}
          DownloadLogic={props.DownloadLogic1}
        />
      )}
      {/* 엑셀 업로드용 숨김 파일 input */}
      <input
        type="file"
        ref={props.fileInputRef}
        style={{ display: 'none' }}
        accept=".xlsx,.xls"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            props.ExcelUpload1?.(file);
            e.target.value = '';
          }
        }}
      />
    </React.Fragment>
  );
}

export default HEA_BASIC_01;
